import React from 'react';
import DueDateCalculator from '../DueDateCalculator';
import { Calculator, DateCalculateBtn, SelectDate } from '../styled';

function index(props) {
  const { setDueDate } = props;
  return (
    <Calculator>
      <h1>Due Date Calculator</h1>
      <p>
        Prepare for baby&apos;s arrival with Mylo Due Date Calculator. Learn
        your due date and begin the countdown to the big day!
      </p>
      <div className="spacingTop">
        <h5>When did your last period start?</h5>
        <DueDateCalculator
          setDueDate={setDueDate}
          DateCalculateBtn={DateCalculateBtn}
          buttonText={'CALCULATE MY DUE DATE'}
          SelectDate={SelectDate}
        />
      </div>
    </Calculator>
  );
}

export default index;
